const TOTP_MESSAGES = {
  SERVER_ERROR: `There was a problem with the authentication.
Please contact us if the error persists`,
  UNAUTHENTICATED: 'Invalid credentials',
};

export { TOTP_MESSAGES };
